
import Vue from 'vue'
import { VTooltip } from 'v-tooltip'
import ErrorModal from '~/components/modals/ErrorModal.vue'
import Modal from '~/components/modals/Modal.vue'

let lottie = null
if (process.client) {
  lottie = require('lottie-web')
}

export default Vue.extend({
  name: 'Test',
  directives: {
    tooltip: VTooltip
  },
  components: {
    Modal,
    ErrorModal,
    Button: () => import('primevue/button'),
    Dialog: () => import('primevue/dialog')
  },
  layout(context) {
    const { route } = context
    if (route.name.includes('user-test')) {
      return 'footer'
    }
  },
  props: {
    parent: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      $gtm: null,
      trackNumber: 0,
      socials: [],
      social: null,
      fromSocial: false,
      status: 1,
      index: 0,
      progress: 0,
      questions: [],
      personality: {},
      popupNoNeutral: false,
      popupError: false,
      showLoginDialog: false,
      error: {},
      slide: 1,
      rating: {
        current: 3,
        min: 1,
        max: 5
      },
      personalityType: '',
      mbti: ''
    }
  },
  head () {
    return {
      title: this.$t('test.pageName') + ' - CVing',
      meta: [
        { property: 'og:site_name,', content: 'CVing - test della personalità' },
        { property: 'fb:app_id', content: 676524417346023 },
        { property: 'og:title', content: this.personalityType },
        { hid: 'ogtitle', property: 'og:title', content: this.personalityType },
        { hid: 'robots', name: 'robots', content: 'noindex,nofollow' },
        { hid: 'description', property: 'description', content: this.$t('test.metaDescription') },
        { hid: 'og:description', property: 'description', content: this.$t('test.metaDescription') }

      ]
    }
  },
  computed: {
    sharedLink() {
      if (!this.mbti && !this.$auth?.user?.mbti) {
        return ''
      }
      const p = this.mbti ? JSON.parse(this.mbti) : JSON.parse(this.$auth.user.mbti)
      const m = 'ie:' + p.ie.toString() + ',ft:' + p.ft.toString() + ',sn:' + p.sn.toString() + ',jp:' + p.jp.toString()

      let url = ''

      /* if (this.$router.currentRoute.fullPath.includes('localhost') || this.$router.currentRoute.fullPath.includes('gcpstaging')) {
        url = 'https://gcpstaging.cving.com/user/results/test'
      } else if (this.$router.currentRoute.fullPath.includes('gcp')) {
        url = 'https://gcp.cving.com/user/results/test'
      } else {
        url = 'https://cving.com/user/results/test'
      } */
      url = 'https://cving.com/user/results/test'
      return `${url}/${this.personalityType}?mbti=${encodeURIComponent(m)}`
    },
    opacityA () {
      let a = 1
      const value = this.rating.current
      const avg = (this.rating.min + this.rating.max) / 2
      if (value > avg) {
        a = 1 - ((value - avg) / (this.rating.max - avg)) + 0.20
      }
      return a
    },
    opacityB () {
      let b = 1
      const value = this.rating.current
      const avg = (this.rating.min + this.rating.max) / 2
      if (value < avg) {
        b = (value - this.rating.min) / (avg - this.rating.min) + 0.20
      }
      return b
    },
    opacityNeutral () {
      let a = 1
      let b = 1
      const value = this.rating.current
      const avg = (this.rating.min + this.rating.max) / 2
      if (value < avg) {
        b = (value - this.rating.min) / (avg - this.rating.min) + 0.20
      }
      if (value > avg) {
        a = 1 - ((value - avg) / (this.rating.max - avg)) + 0.20
      }
      return (b < a) ? b : a
    },
    opacitySometimes1 () {
      let a = 1
      let b = 1
      const value = this.rating.current
      const avg = (this.rating.min + this.rating.max) / 2
      if (value < avg) {
        b = (value - this.rating.min) / (avg - this.rating.min) + 0.20
      }
      if (value > avg) {
        a = 1 - ((value - avg) / (this.rating.max - avg)) + 0.20
      }
      return (b < a) ? b * 2 : a
    },
    opacitySometimes2 () {
      let a = 1
      let b = 1
      const value = this.rating.current
      const avg = (this.rating.min + this.rating.max) / 2
      if (value < avg) {
        b = (value - this.rating.min) / (avg - this.rating.min) + 0.20
      }
      if (value > avg) {
        a = 1 - ((value - avg) / (this.rating.max - avg)) + 0.20
      }
      return (b < a) ? b : a * 2
    }
  },
  created () {
    console.log('created')
    if (this.$route && this.$route.params && this.$route.params.from === 'social') {
      // aggiungere params per description
      console.log('social')
      this.fromSocial = true
      const p = this.$route.params.mbti ? JSON.parse(this.$route.params.mbti) : ''
      if (p) {
        this.getPersonality(p.ie, p.sn, p.ft, p.jp)
      }
      this.status = 3
    } else if (!this.$auth.user || this.$auth?.user?.mbti === '') {
      this.initTest()
    } else {
      const p = JSON.parse(this.$auth?.user?.mbti)
      if (p) {
        this.getPersonality(p.ie, p.sn, p.ft, p.jp)
        this.status = 3
      } else {
        this.initTest()
      }
    }
  },
  mounted () {
    lottie.loadAnimation({
      container: document.getElementById('bm'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/images/animations/personality_blue.json'
    })
    if (!this.$auth.user || this.$auth?.user?.mbti === '') {
      this.track(this.trackNumber, 'open')
    }
  },
  methods: {
    formatText(text) {
      if (!text) { return '' }
      text = text.trim()
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    track (number, stage) {
      this.$gtm.push({
        event: 'personality_test',
        event_data: {
          step_number: number,
          step_stage: stage,
          page_url: this.$router.currentRoute.fullPath,
          page_title: this.$t('test.pageName') + ' - CVing'
        }
      })
    },
    openSocial (el) {
      const index = this.socials.indexOf(el)
      if (index === -1) {
        this.socials.push(el)
      }
    },
    closeSocial (el) {
      const index = this.socials.indexOf(el)
      this.socials.splice(index, 1)
    },

    downloadImage () {
      fetch('https://storage.googleapis.com/cving-prod/personality_test/' + this.personality.type + '_stories.png')
        .then(resp => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          // the filename you want
          a.download = this.personality.type
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch((error) => {
          alert('An error sorry')
          if (this.$auth.loggedIn) {
            this.$sentry.setTag('email', this.$auth.user.email)
          }
          this.$sentry.captureException(error)
        })
    },
    // comment
    goToTest () {
      this.status = 2
      this.trackNumber = this.trackNumber + 1
      this.track(this.trackNumber, 'start')
    },
    goToSlide (slide) {
      this.slide = slide
      this.$nextTick(() => {
        this.loadLottie(slide)
      })
    },
    initTest () {
      this.index = 0
      this.progress = 0
      const base = this.$i18n.messages[this.$i18n.locale]
      const n = Object.getOwnPropertyNames(base.test.questions)
      this.questions = []
      for (let i = 0; i < n.length; i++) {
        const q = base.test.questions[n[i]]
        const obj = { id: n[i], rating: this.rating.current, a: q.a, b: q.b }
        this.questions.push(obj)
      }
      // console.log('questions', this.questions)
      // this.updateProgress()
    },
    nextQuestion () {
      // eslint-disable-next-line unicorn/prefer-includes
      if (this.questions[this.index].id.indexOf('i') > -1 && this.rating.current === 3) {
        this.popupNoNeutral = true
      } else {
        this.track(this.trackNumber, 'end')
        this.questions[this.index].rating = this.rating.current
        if (this.index + 1 < this.questions.length) {
          this.index++
          this.rating.current = this.questions[this.index].rating
          // this.sliderChange(this.rating.current)
          this.updateProgress()
          this.trackNumber = this.trackNumber + 1
          this.track(this.trackNumber, 'start')
        } else {
          this.track(0, 'end')
          this.trackNumber = 0
          this.finishTest()
        }
      }
    },
    hidePopup () {
      this.popupNoNeutral = false
      this.popupError = false
    },
    proceedToResults () {
      this.showLoginDialog = false
      this.$router.push(this.localePath('/user/settings/personality-test'))
    },
    canGoToNextQuestion () {
      // return this.questions[this.index].id.indexOf('i') > -1 && this.rating.current === 3
      return false
    },
    prevQuestion () {
      this.questions[this.index].rating = this.rating.current
      if (this.index > 0) {
        this.index--
        this.rating.current = this.questions[this.index].rating
        // this.sliderChange(this.rating.current)
        this.updateProgress()
        this.trackNumber = this.trackNumber - 1
        this.track(this.trackNumber, 'start')
      }
    },
    updateProgress () {
      this.progress = ((this.index + 1) / this.questions.length) * 100
    },
    finishTest () {
      const p = this.getPersonality()
      if (p.inconclusive) {
        console.log('inconclusive')
        this.inconclusiveTest(p)
      } else if (!this.$auth.user) {
        const mbti = JSON.stringify({ ie: p.ie, ft: p.ft, sn: p.sn, jp: p.jp })
        this.mbti = mbti
        if (process.client) {
          sessionStorage.setItem('pending_mbti', mbti)
        }
        this.trackNumber = this.trackNumber + 1
        this.showLoginDialog = true
      } else {
        this.trackNumber = this.trackNumber + 1
        this.updateUser(p)
        this.status = 3
      }
    },
    getPersonality (ie, sn, ft, jp) {
      console.log('get personality')
      const p = {}

      if (typeof sn === 'undefined') {
        sn = 12.0 + this.questions[3].rating + this.questions[7].rating + this.questions[11].rating + this.questions[15].rating + this.questions[19].rating - this.questions[23].rating - this.questions[27].rating + this.questions[31].rating
      }

      if (typeof ie === 'undefined') {
        ie = 30.0 - this.questions[2].rating - this.questions[6].rating - this.questions[10].rating + this.questions[14].rating - this.questions[18].rating + this.questions[22].rating + this.questions[26].rating - this.questions[30].rating
      }

      if (typeof ft === 'undefined') {
        ft = 30.0 - this.questions[1].rating + this.questions[5].rating + this.questions[9].rating - this.questions[13].rating - this.questions[17].rating + this.questions[21].rating - this.questions[25].rating - this.questions[29].rating
      }

      if (typeof jp === 'undefined') {
        jp = 18.0 + this.questions[0].rating + this.questions[4].rating - this.questions[8].rating + this.questions[12].rating - this.questions[16].rating + this.questions[20].rating - this.questions[24].rating + this.questions[28].rating
      }

      p.ie = ie
      p.sn = sn
      p.ft = ft
      p.jp = jp

      const base = this.$i18n.messages[this.$i18n.locale]
      const n = Object.getOwnPropertyNames(base.test.inconclusive_questions)
      const cases = ['ie', 'sn', 'ft', 'jp']
      for (let i = 0; i < n.length; i++) {
        const q = this.searchQuestionById(n[i])
        if (q !== null) {
          if (q.rating !== (this.rating.min + this.rating.max) / 2) {
            p[cases[i]] += q.rating > (this.rating.min + this.rating.max) / 2 ? 0.5 : -0.5
          }
        }
      }

      p.i_p = 0
      p.e_p = 0
      p.s_p = 0
      p.n_p = 0
      p.f_p = 0
      p.t_p = 0
      p.j_p = 0
      p.p_p = 0

      p.type = ''
      p.inconclusive = false

      if (p.ie === 24) {
        p.type = 'x'
        p.inconclusive = true
        p.i_p = 50
        p.e_p = 50
      } else if (p.ie < 24) {
        p.type = 'I'
        p.i_p = Math.round(this.normalized(p.ie, 0, 24, 100, 50))
        p.e_p = 100 - p.i_p
      } else if (p.ie > 24) {
        p.type = 'E'
        p.e_p = Math.round(this.normalized(p.ie, 24, 48, 50, 100))
        p.i_p = 100 - p.e_p
      }

      if (p.sn === 24) {
        p.type += 'x'
        p.inconclusive = true
        p.s_p = 50
        p.n_p = 50
      } else if (p.sn < 24) {
        p.type += 'S'
        p.s_p = Math.round(this.normalized(p.sn, 0, 24, 100, 50))
        p.n_p = 100 - p.s_p
      } else if (p.sn > 24) {
        p.type += 'N'
        p.n_p = Math.round(this.normalized(p.sn, 24, 48, 50, 100))
        p.s_p = 100 - p.n_p
      }

      if (p.ft === 24) {
        p.type += 'x'
        p.inconclusive = true
        p.f_p = 50
        p.t_p = 50
      } else if (p.ft < 24) {
        p.type += 'F'
        p.f_p = Math.round(this.normalized(p.ft, 0, 24, 100, 50))
        p.t_p = 100 - p.f_p
      } else if (p.ft > 24) {
        p.type += 'T'
        p.t_p = Math.round(this.normalized(p.ft, 24, 48, 50, 100))
        p.f_p = 100 - p.t_p
      }

      if (p.jp === 24) {
        p.type += 'x'
        p.inconclusive = true
        p.j_p = 50
        p.p_p = 50
      } else if (p.jp < 24) {
        p.type += 'J'
        p.j_p = Math.round(this.normalized(p.jp, 0, 24, 100, 50))
        p.p_p = 100 - p.j_p
      } else if (p.jp > 24) {
        p.type += 'P'
        p.p_p = Math.round(this.normalized(p.jp, 24, 48, 50, 100))
        p.j_p = 100 - p.p_p
      }
      if (!p.inconclusive) {
        p.motto = this.$t('test.personality.motto.' + p.type)
        p.described_as = this.$t('test.personality.described_as.' + p.type)
        p.the_most = this.$t('test.personality.the_most.' + p.type)
        p.general = this.$t('test.personality.general.' + p.type)
        p.careers = this.$t('test.personality.carriers.' + p.type)
        p.cognitive_functions = this.$t('test.personality.cognitive_functions.' + p.type)
        p.shadow_functions = this.$t('test.personality.shadow_functions.' + p.type)
        p.short_description = this.$t('test.personality.short_description.' + p.type)
        p.personalityType = this.$t('test.personality.type.' + p.type)
        this.personalityType = p.type
      }

      this.personality = p
      console.log('personality', this.personality)
      return p
    },
    loadLottie (step) {
      const value = parseInt(step) - 1
      lottie.destroy()
      const gender = this.$auth?.user?.gender ? this.$auth.user.gender : 'f'
      const skinTone = this.$auth?.user?.avatar_skin_tone ? this.$auth.user.avatar_skin_tone : '2'
      lottie.loadAnimation({
        container: document.getElementById('bm' + step),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/assets/images/animations/personality/' + this.personality.type.toLowerCase() + '/' + this.personality.type.toLowerCase() + '' + value + '_' + gender + '_' + skinTone + '.json'
      })
    },
    async updateUser (p) {
      const mbti = JSON.stringify({ ie: p.ie, ft: p.ft, sn: p.sn, jp: p.jp })
      const updatedUser = { ...this.$auth.user }
      updatedUser.mbti = mbti
      updatedUser.personality = p
      if (this.$auth.user.personality_type !== 'default') {
        updatedUser.personality_type = this.$testResults(mbti)
      }
      this.$auth.setUser(updatedUser)
      // this.$nuxt.$loading?.start()
      try {
        const deepCopy = JSON.parse(JSON.stringify(updatedUser))
        delete deepCopy.personality
        await this.$axios.post('/proxyapi/auth/update-user', deepCopy)
      } catch ({ response }) {
        // console.log('fail', response)
      }
    },
    inconclusiveTest (personality) {
      const base = this.$i18n.messages[this.$i18n.locale]
      const indexes = []

      if (personality.ie === 24) {
        if (this.searchQuestionById('i1') === null) {
          indexes.push('i1')
        }
      }

      if (personality.sn === 24) {
        if (this.searchQuestionById('i2') === null) {
          indexes.push('i2')
        }
      }

      if (personality.ft === 24) {
        if (this.searchQuestionById('i3') === null) {
          indexes.push('i3')
        }
      }

      if (personality.jp === 24) {
        if (this.searchQuestionById('i4') === null) {
          indexes.push('i4')
        }
      }

      console.log('indexes', indexes)
      for (let i = 0; i < indexes.length; i++) {
        const index = indexes[i]
        const q = base.test.inconclusive_questions[index]
        const obj = { id: index, rating: (this.rating.min + this.rating.max) / 2, a: q.a, b: q.b }
        this.questions.push(obj)
      }

      if (indexes.length > 0) {
        this.nextQuestion()
      }
    },
    searchQuestionById (id) {
      for (let i = 0; i < this.questions.length; i++) {
        const q = this.questions[i]
        if (q.id === id) {
          return q
        }
      }
      return null
    },
    getPercentage (value, forced) {
      if (typeof forced === 'undefined') { forced = false }
      if (value <= 50 && forced === false) {
        return 0
      } else {
        return Math.round(this.normalized(value, 50, 100, 0, 100))
      }
    },
    normalized (value, rangeMin, rangeMax, resultMin, resultMax, contenitive, ratio, shiftUnderZero, symmetric) {
      if (typeof contenitive === 'undefined') { contenitive = true }
      if (typeof ratio === 'undefined') { ratio = 1 }
      if (typeof shiftUnderZero === 'undefined') { shiftUnderZero = false }
      if (typeof symmetric === 'undefined') { symmetric = false }
      if (contenitive) {
        if (rangeMin > rangeMax) {
          console.log('Normalizer WARNING! - rangeMin is bigger than rangeMax, this way the result wil go out of range, invert the result instead!')
        }
        value = Math.max(value, rangeMin)
        value = Math.min(value, rangeMax)
      }
      if (ratio !== 1) {
        if (ratio < 0) { ratio = 1 / Math.abs(ratio) }
        if (shiftUnderZero) {
          // Porta tutto sopra 0 così la trasformazione è continua e non ha un centro per la non linearità
          if (rangeMin < 0) {
            const shift = 0 - rangeMin
            value = value + shift
            rangeMax = rangeMax + shift
            rangeMin = rangeMin + shift
          }
          if (value < 0) {
            console.log('Normalizer WARNING! - value out of bounds and smaller than zero!')
          }
        } else if (symmetric) {
          // sposta il centro del range sullo zero
          const shift = (rangeMax - rangeMin) / 2 - rangeMax
          value = value + shift
          rangeMin = rangeMin + shift
          rangeMax = rangeMax + shift
        }
        value = value >= 0 ? Math.pow(value, ratio) : -1 * Math.pow(Math.abs(value), ratio)
        rangeMin = rangeMin >= 0 ? Math.pow(rangeMin, ratio) : -1 * Math.pow(Math.abs(rangeMin), ratio)
        rangeMax = rangeMax >= 0 ? Math.pow(rangeMax, ratio) : -1 * Math.pow(Math.abs(rangeMax), ratio)
      }
      const standardDev = (resultMax - resultMin) / (rangeMax - rangeMin)
      return value * standardDev + resultMin - rangeMin * standardDev
    },
    repeatTest () {
      this.trackNumber = 0
      this.slide = 1
      this.status = 1
      this.personality = {}
      this.rating.current = 3
      this.initTest()
      lottie.destroy()
      lottie.loadAnimation({
        container: document.getElementById('bm'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/assets/images/animations/personality_blue.json'
      })
    },
    async nativeShare () {
      const response = await fetch('https://storage.googleapis.com/cving-prod/personality_test/' + this.personality.type + '_stories.png')
      const blob = await response.blob()
      const filesArray = [
        new File(
          [blob],
          this.personality.type + '.png',
          {
            type: 'image/png',
            lastModified: new Date().getTime()
          }
        )
      ]

      let title = null
      if (this.social === 'facebook' || this.social === 'twitter' || this.social === 'linkedin') {
        title = this.$t('testTranslationTitle.' + this.personality.type)
      } else {
        title = this.$t('testTranslation.' + this.personality.type)
      }

      if (navigator.share) {
        navigator.share({
          files: filesArray,
          text: this.$t('test.metaDescription'),
          title,
          url: this.sharedLink
        })
      } else {
        console.log('The native share feature is not implemented')
      }
    }
  }
})
